import React, { useState } from 'react';

interface ModuleCardProps {
  title: string;
  description: string;
  icon?: string;
  imageSrc?: string;
  onClick: () => void;
  backgroundColor?: string;
}

const ModuleCard: React.FC<ModuleCardProps> = React.memo(({
  title,
  description,
  icon,
  imageSrc,
  onClick,
  backgroundColor = '#ffffff',
}) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div
      className="module-card"
      style={{
        ...styles.card,
        backgroundColor,
      }}
      onClick={onClick}
    >
      <div style={styles.imageWrapper}>
        {imageSrc && !imageError ? (
          <img
            src={imageSrc}
            alt={title}
            style={styles.image}
            onError={() => setImageError(true)}
          />
        ) : (
          <div style={styles.fallbackIcon}>{icon || '📦'}</div>
        )}
      </div>
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.description}>{description}</p>
    </div>
  );
});

const styles: Record<string, React.CSSProperties> = {
  card: {
    borderRadius: '20px',
    padding: '20px 16px 16px 16px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: '1px solid #eef2f6',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1), 0 1px 3px rgba(0,0,0,0.05)',
    position: 'relative',
    overflow: 'visible',
    height: '240px', // уменьшенная высота (было 280px)
    width: '100%',
    boxSizing: 'border-box',
  },
  imageWrapper: {
    marginTop: '-32px', // чуть уменьшили выдвижение
    marginBottom: '8px',
    width: '70px',
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    filter: 'drop-shadow(0 8px 12px rgba(0,0,0,0.15))',
    flexShrink: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  fallbackIcon: {
    fontSize: '40px',
    lineHeight: 1,
  },
  title: {
    fontSize: '16px',
    marginBottom: '6px',
    color: '#1a1a2e',
    fontWeight: 600,
  },
  description: {
    fontSize: '13px',
    color: '#666',
    lineHeight: 1.4,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    maxHeight: '4.2em',
    margin: 0,
  },
};

export default ModuleCard;